import { jwtDecode } from "jwt-decode";

// parse the JWT token and return true if they have the same content,
// are expiring at the same time (with a 15 minutes margin),
// ignoring the iat, jti fields
export function sameToken(token1: string, token2: string): boolean {
  try {
    const decoded1 = jwtDecode(token1);
    const decoded2 = jwtDecode(token2);
    if (
      !decoded1.exp ||
      !decoded2.exp ||
      Math.abs(decoded1.exp - decoded2.exp) > 15 * 60
    ) {
      return false;
    }
    delete decoded1.exp;
    delete decoded1.iat;
    delete decoded1.jti;
    delete decoded2.exp;
    delete decoded2.iat;
    delete decoded2.jti;
    // reorder the object keys to ensure the comparison is correct
    const decoded1Ordered = Object.fromEntries(Object.entries(decoded1).sort());
    const decoded2Ordered = Object.fromEntries(Object.entries(decoded2).sort());
    return JSON.stringify(decoded1Ordered) === JSON.stringify(decoded2Ordered);
  } catch {
    return false;
  }
}
